<template>
  <div class="item-name">
      <span>{{ShowName}}
          <a > </a>
      </span>
  </div>
</template>

<script>
export default {
  name: "RlTitle",
  props:{
    ShowName:{
        type: String
    }
  }
}
</script>

<style lang="less" scoped>
.item-name{
    text-align: center;
    font-size: 32px;
    padding: 80px 0 90px 0;
    animation: Name 2s ease;
    span{
      height: 32px;
      font-size: 32px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #333333;
      line-height: 48px;
      letter-spacing: 1px;
      display: block;
      position: relative;
    }
    a{
      width: 32px;
      height: 6px;
      background: #358ED7;
      border-radius: 2px;
      position: absolute;
      top: 52px;
      left: 49%;
    }

}
  @-webkit-keyframes Name {
    from{
      opacity: 0;
      transform: translateY(20px);
    }
    to{
      opacity: 1;
    }
  }
</style>